// extracted by mini-css-extract-plugin
export default {"imagePlaceholder":"FundingTierNftPreviewAssets_imagePlaceholder__FCYHm"};